<template>
  <v-card>
    <v-card-title class="pl-4" style="height: 64px">
      <span :class="data.name ? '':'grey--text'" class="title pr-4">{{data.name || '未命名'}}</span>
      <div>
        <v-layout class="text-xs-right" wrap>
          <v-flex xs6>
            <span class="grey--text caption mr-2">登记时间</span>
            <span class="pr-4">{{timeStringify(data.creationTime)}}</span>
          </v-flex>
          <v-flex xs6>
            <span class="grey--text caption mr-2">上次更新</span>
            <span class="pr-4">{{timeStringify(data.lastUpdateTime)}}</span>
          </v-flex>
        </v-layout>
      </div>
      <v-spacer></v-spacer>
      <slot name="actions"></slot>
    </v-card-title>
    <v-card-text>
      <!--<h3>{{data === null}}/{{data}}/</h3>-->
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="用户姓名"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.person"
              v-model="data.name"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="用户账号"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.loginId"
              v-model="data.loginId"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="电子邮箱"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.email"
              v-model="data.email"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="电话号码"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.phone"
              v-model="data.phone"
            ></v-text-field>
          </v-flex>
          <!--<v-flex xs4>-->
          <!--<v-text-field-->
          <!--disabled-->
          <!--label="证件类型"-->
          <!--placeholder="N/A"-->
          <!--prepend-icon="$vuetify.icons.idCardType"-->
          <!--&gt;</v-text-field>-->
          <!--</v-flex>-->
          <!--<v-flex xs4>-->
          <!--<v-text-field-->
          <!--disabled-->
          <!--label="证件号码"-->
          <!--placeholder="N/A"-->
          <!--prepend-icon="$vuetify.icons.idCard"-->
          <!--&gt;</v-text-field>-->
          <!--</v-flex>-->
          <v-flex sm4 xs12>
            <v-text-field
              disabled
              label="登记类型"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.group"
              v-model="data.typeName"
            ></v-text-field>
          </v-flex>
          <v-flex sm4 xs12>
            <v-text-field
              :value="data.orgGroupName"
              disabled
              label="所在单位"
              placeholder="N/A"
              prepend-icon="$vuetify.icons.org"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-select chips :items="data.groupList" item-text='name' item-value="id" label="驾驶员所属单位列表" prepend-icon="$vuetify.icons.group" disabled multiple
            v-model="data.driverOrgs"></v-select>
          </v-flex>
          <v-layout column class="pl-4">
            <v-flex xs12>
              <v-subheader>驾驶证明</v-subheader>
              <l-image v-if="data.driverLicense.length === 0"></l-image>
              <l-image-dialog
                :src="img.src"
                v-for="(img,i) in data.driverLicense" :key="i">
                <l-image
                  slot="activator"
                  :src="img.src"
                  :error="img.error"
                  :errorMessage="img.errorMessage"
                >
                  <template slot="action">

                  </template>
                </l-image>
              </l-image-dialog>
            </v-flex>
          </v-layout>
          <v-flex justify-start xs12 v-if="from==='superAdmin'">
            <v-btn flat color="primary" @click="showExtraInfo" v-show="!showExtend">展示附加信息</v-btn>
            <v-btn flat color="primary" @click="showExtraInfo" v-show="showExtend">隐藏附加信息</v-btn>
          </v-flex>
          <v-layout column xs12 v-if="showExtend&&data.extend.length!==0">
            <v-layout v-for="(p,index) in data.extend" :key="index">
              <v-flex xs3>
                <v-text-field label="Key" v-model="p.key" prepend-icon="$vuetify.icons.code" disabled></v-text-field>
              </v-flex>
              <v-flex xs9>
                <v-textarea label="参数值" v-model="p.value" prepend-icon="$vuetify.icons.comment" rows="1" auto-grow disabled></v-textarea>
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout justify-center xs12 v-if="showExtend&&data.extend.length===0">
            <p>暂无附加信息</p>
          </v-layout>
        </v-layout>
        <v-subheader>绑定分组</v-subheader>
        <v-layout wrap>
          <v-flex xs12>
            <l-data-table
              :headers="groupHeaders"
              :items="data.groupList"
              flat
              hide-title
              no-data-text="没有绑定分组"
            ></l-data-table>
          </v-flex>
        </v-layout>
        <v-subheader>绑定角色</v-subheader>
        <v-layout wrap>
          <v-flex xs12>
            <l-data-table
              :headers="roleHeaders"
              :items="data.roleList"
              flat
              hide-actions
              hide-title
              no-data-text="没有绑定角色"
            ></l-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import {time} from '../../../../ladmin/utils/time'
import {GROUP_ACTION_HEADERS} from '../../../../consts/userAdmin'
export default {
  name: 'userDetailsContent',
  props: {
    data: {type: Object, default: () => ({})},
    from: {type: String, default: ''}
  },
  data: () => ({
    groupHeaders: GROUP_ACTION_HEADERS,
    roleHeaders: [
      {text: '角色名称', value: 'name', align: 'left', placeholder: 'N/A'},
      {text: '角色描述', value: 'description', align: 'right', placeholder: 'N/A'},
      {text: '上次修改', value: 'lastEditor', align: 'right', placeholder: 'N/A'},
      {text: '创建时间', value: 'creationTime', align: 'right', placeholder: 'N/A', f: v => time.stringify(v)},
    ],
    showExtend: false,
  }),
  computed: {},
  watch: {},
  methods: {
    timeStringify (t) {
      return time.stringify(t)
    },
    showExtraInfo () {
      this.showExtend = !this.showExtend
      this.$emit('showExtraInfo', this.showExtend)
    },
    getReservations ({pagination, sortStack, filterItems}) {
      return this.$store.dispatch('reservation/getReservations', {
        pagination: {page: 1, rowsPerPage: 5},
        sortStack,
        filter: filterItems,
        locate: this.showReservationHistory ? 'history' : 'runtime',
        search: {
          key: 'ownerId', value: this.data.loginId,
        }
      })
    },
    async goReservation ({item}) {
      const map = {
        [Reservation.PERSONAL]: 'PersonalReservationDetails',
        [Reservation.ORG]: 'OrgReservationDetails',
        [Reservation.ADMIN]: 'AdminReservationDetails',
      }
      let routeName = map[item.type]
      if (routeName) {
        this.$router.push({
          name: routeName,
          params: {
            plate: item.plate
          },
          query: {id: item.id}
        })
      }
      else {
        let res = await this.$store.dispatch('reservation/getReservationObgrp', {ownerId: item.ownerId})
        console.log(res)
        let extend = JSON.parse(res.items[0].obgrp.extend)
        this.$router.push({
          name: 'reservationDetails',
          query: {id: extend.procInstId, status: 'read', obGrpName: ''}})
      }
    },
    async addFile (file, target) {
      // file 实际上为fileList
      let imageCheckType = ['jpg', 'jpeg', 'png', 'gif']
      let IMAGE_MAX_SIZE = 5 * 1000 * 1000
      for (let f of file) {
        let checkType = imageCheckType
        let maxSize = IMAGE_MAX_SIZE
        // console.log('get file', f)
        let suffix = /\.([^.]*)$/i.exec(f.name)[1]
        if (checkType.indexOf(suffix) === -1) {
          this.$L.error({
            title: '上传文件格式错误',
            message: `上传格式: ${suffix}, 支持的格式: ${checkType.join(',')}`
          })
          return
        }
        else if (f.size > maxSize) {
          this.$L.error({
            title: '文件容量过大',
            message: `文件大小: ${Math.round(f.size / 1000)}KB, 最大限制: ${Math.round(maxSize / 1000)}KB`
          })
          return
        }
      }

      let temp = new Image()
      temp.loading = true
      if (target instanceof Array) {
        target.push(temp)
        // 上传图片
        let img = await this.uploadFile(file)
        this.$set(target, target.length - 1, img)
        // console.log(this.vehicleForm.driverLicense)
        this.getImg(img)
      }
    },
    deleteImage (target, i) {
      target.splice(i, 1)
    },
    async uploadFile (files) {
      if (files instanceof Object && files.length > 0) {
        let file = files[0]
        let img = new Image()
        // console.log(img)
        try {
          let res = await this.$store.dispatch('uploadFile', {file, url: '/passApi/check/file'})
          img.url = res
        }
        catch (e) {
          img.error = true
          img.errorMessage = e.message
        }
        return img
      }
    },
    async getImg (img) {
      // console.log(img)
      img.loading = true
      let path = img.url
      this.$set(img, 'src', 'https://smaco2.uestc.edu.cn/passApi' + path)
      img.loading = false
    },
  },
  created () {
  }
}
</script>

<style scoped>

</style>
